// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__X4iDL","headerResponsive":"PageHeader_headerResponsive__fx7pK"};